//import React, { useState, useCallback } from "react";
//import Gallery from "react-photo-gallery";
//import Carousel, { Modal, ModalGateway } from "react-images";
//// import FsLightbox from 'fslightbox-react';
//
//
//
//const images = [
//{
//        src:require("../img/Background Layout/MGDDS1/BoroughHallEXTA0001b_bg_clean_v001.webp"),
//        width: 2560,
//        height: 1572
//    },
//     {
//            src:require("../img/Background Layout/MGDDS1/BoroughHallEXTA0006_bg_clean_v001.webp"),
//            width: 2560,
//           height:1664
//        },
//         {
//                    src:require("../img/Background Layout/MGDDS1/LESStreetA0187_bg_clean_v001.webp"),
//                    width: 2560,
//                    height: 1374
//                },
//    {
//        src:require("../img/ChangEFactoryESTA0001_design_clean_v002.png"),
//        width: 3320,
//        height: 1920
//    },
//    {
//        src:require("../img/LanternCityTheatreESTA0004_design_clean_v001.png"),
//        width: 1920,
//        height: 2484
//    },
//
//    {
//        src:require("../img/MountainPeakFlashbackA0007_design_clean_v002.png"),
//        width: 3412,
//        height: 1920
//    },
//    {
//        src:require("../img/DBKFoundryWorkshopA0009_design_clean_v002.png"),
//        width: 3431,
//        height: 1920
//    },
//    {
//        src:require("../img/DBKFoundryEXTA0005b_design_clean_v001.png"),
//        width: 2267,
//        height: 1920
//    },
//    {
//        src:require("../img/DBKFoundryDiningHallA0024_design_clean_v002.png"),
//        width: 2789,
//        height: 1920
//    },
//    {
//        src:require("../img/DBKFoundryDiningHallA0014_design_clean_v002.png"),
//        width: 3366,
//        height: 1920
//    },
//    {
//        src:require("../img/GiantLanternINTST01A0014_design_clean_v002.png"),
//        width: 2868,
//        height: 1920
//    },
//    {
//        src:require("../img/GiantLanternINTA0036_design_clean_v002.png"),
//        width: 3169,
//        height: 1920
//    },
//    {
//        src:require("../img/GiantLanternEXTA0003_design_clean_v002.png"),
//        width: 1911,
//        height: 1920
//    },
//    {
//        src:require("../img/MountainPeakDestroyedST02EXTA0008_design_clean_v002.png"),
//        width: 2954,
//        height: 1920
//    },
//    {
//        src:require("../img/MountainPeakDestroyedST01EXTA0008_design_clean_v002.png"),
//        width: 3954,
//        height: 1920
//    },
//
//    {
//        src:require("../img/LanternCityMarketEXTA0007_design_clean_v003.png"),
//        width: 3413,
//        height: 1920
//    },
//    {
//        src:require("../img/LanternCityMarketEXTA0005_design_clean_v001.png"),
//        width: 3270,
//        height: 1920
//    },
//    {
//        src:require("../img/LanternCityMarketEXTA0001_design_clean_v001.png"),
//        width: 3413,
//        height: 1920
//    },
//    {
//        src:require("../img/LadyBoneDemonTowerEXTA0035_design_clean_v002.png"),
//        width: 3120,
//        height: 1920
//    },
//
//    {
//        src:require("../img/DOEPalaceEXTA0035_design_clean_v003.png"),
//        width: 3249,
//        height: 1920
//    },
//    {
//        src:require("../img/DOEPalaceEXTA0026_design_clean_v001.png"),
//        width: 3416,
//        height: 1920
//    },
//    {
//        src:require("../img/DesertOasisShackA0039_design_clean_v003.png"),
//        width: 3412,
//        height: 1920
//    },
//
//    {
//        src:require("../img/ChangEKitchenINTA0014_design_clean_v003.png"),
//        width: 2752,
//        height: 1920
//    },
//    {
//        src:require("../img/ChangEKitchenINTA0012_design_clean_v003.png"),
//        width: 2631,
//        height: 1920
//    },
//    {
//        src:require("../img/ChangEKitchenINTA0008_design_clean_v002.png"),
//        width: 3249,
//        height: 1920
//    },
//    {
//        src:require("../img/ChangEFactoryINTA0003_design_clean_v003.png"),
//        width: 3319,
//        height: 1920
//    },
//
//    {
//        src:require("../img/ChangEFactoryINTA0002_design_clean_v001.png"),
//        width: 2933,
//        height: 1920
//    },
//    {
//        src:require("../img/MountainRetreatEXTA0067_design_clean_v001.png"),
//        width: 4756,
//        height: 1920
//    },
//    {
//        src:require("../img/MountainRetreatEXTA0037_design_clean_v002.png"),
//        width: 3196,
//        height: 1836
//    },
//    {
//        src:require("../img/LegoCaveSpiderQueenLabA0121_design_clean_v002.png"),
//        width: 1920,
//        height: 1083
//    },
//    {
//        src:require("../img/LegoCaveSpiderQueenLabA0121b_design_clean_v002.png"),
//        width: 1920,
//        height: 1131
//    },
//    {
//        src:require("../img/LegoCaveSpiderQueenThroneLairA0002_design_clean_v001.png"),
//        width: 1920,
//        height: 1080
//    },
//    {
//        src:require("../img/LegoDesertBattleAreaA0034_design_clean_v001.png"),
//        width: 1920,
//        height: 572
//    },
//    {
//        src:require("../img/LegoFFMountainMKingLivingRoomA0007_design_clean_v002.png"),
//        width: 1920,
//        height: 1150
//    },
//    {
//        src:require("../img/LegoFloatingHQEXTA0011_design_clean_v001.png"),
//        width: 1920,
//        height: 1083
//    },
//    {
//        src:require("../img/LegoFloatingHQEXTDeckA0071_design_clean_v001.png"),
//        width: 1920,
//        height: 1080
//    },
//    {
//        src:require("../img/LegoFloatingHQEXTDeckA0082_design_clean_v001.png"),
//        width: 1920,
//        height: 1379
//    },
//    {
//        src:require("../img/LegoJungleBattleAreaINTA0015_design_clean_v001.png"),
//        width: 1920,
//        height: 1194
//    },
//    {
//        src:require("../img/LegoJungleBattleAreaINTA0016_design_clean_v002.png"),
//        width: 1920,
//        height: 1082
//    },
//    {
//        src:require("../img/LegoJungleBattleAreaINTA0017_design_clean_v002.png"),
//        width: 1920,
//        height: 1079
//    },
//    {
//        src:require("../img/LegoShadowTheatreINTA0036_design_clean_v002.png"),
//        width: 1920,
//        height: 1228
//    },
//    {
//        src:require("../img/LegoShadowTheatreINTA0052_design_clean_v002.png"),
//        width: 1920,
//        height: 1476
//    },
//    {
//        src:require("../img/LegoShadowTheatreINTA0056_design_clean_v001.png"),
//        width: 1920,
//        height: 1705
//    },
//    {
//        src:require("../img/LegoShadowTheatreINTA0061_design_clean_v001.png"),
//        width: 1920,
//        height: 1080
//    },
//    {
//        src:require("../img/LegoShadowTheatreINTA0063_design_clean_v002.png"),
//        width: 1920,
//        height: 744
//    },
//    {
//        src:require("../img/LegoShadowTheatreINTA0067_design_clean_v001.png"),
//        width: 1920,
//        height: 2212
//    },
//    {
//        src:require("../img/LegoShadowTheatreINTA0068_design_clean_v001.png"),
//        width: 1920,
//        height: 1098
//    },
//    //     {
//    //     src:require("../img/Study 01.png"),
//    //     title:"study",
//    //     width: 64,
//    //     height: 27
//    // },{
//    //     src:require("../img/Study 02.png"),
//    //     title:"study",
//    //     width: 64,
//    //     height: 27
//    // },{
//    //     src:require("../img/Study 03.png"),
//    //     title:"Journey 03",
//    //     width: 64,
//    //     height: 27
//    // },{
//    //     src:require("../img/BM 01.png"),
//    //     title:"Journey 03",
//    //     width: 64,
//    //     height: 27
//    // },{
//    //     src:require("../img/BM 02.png"),
//    //     title:"study",
//    //     width: 64,
//    //     height: 27
//    // },{
//    //     src:require("../img/BM 03.png"),
//    //     title:"study",
//    //     width: 64,
//    //     height: 27
//    // },{
//    //     src:require("../img/BM 04.png"),
//    //     title:"study",
//    //     width: 64,
//    //     height: 27
//    // },{
//    //     src:require("../img/BM 05.png"),
//    //     title:"study",
//    //     width: 64,
//    //     height: 27
//    // },{
//    //     src:require("../img/BM 06.png"),
//    //     title:"study",
//    //     width: 64,
//    //     height: 27
//    // }
//]
//
//export default function SketchImage() {
//
//    const [currentImage, setCurrentImage] = useState(0);
//    const [viewerIsOpen, setViewerIsOpen] = useState(false);
//
//    const openLightbox = useCallback((event, { photo, index }) => {
//        setCurrentImage(index);
//        setViewerIsOpen(true);
//    }, []);
//
//    const closeLightbox = () => {
//        setCurrentImage(0);
//        setViewerIsOpen(false);
//    };
//
//    let width = window.innerWidth;
//    if (width > 1500){ return (
//        <div style={{paddingTop:"2%",width:"80vw",margin:"0 auto"}}>
//            <Gallery targetRowHeight={800} direction={"row"} photos={images} onClick={openLightbox} margin={10} limitNodeSearch={3} />
//            <ModalGateway>
//                {viewerIsOpen ? (
//                    <Modal  onClose={closeLightbox}>
//                        <Carousel
//                            currentIndex={currentImage}
//                            views={images.map(x => ({
//                                ...x,
//                                srcset: x.srcSet,
//                                caption: x.title,
//                            }))}
//                        />
//                    </Modal>
//                ) : null}
//            </ModalGateway>
//        </div>
//    );}
//    else {return ( <div style={{paddingTop:"2%",width:"80vw",margin:"0 auto"}}>
//        <Gallery  direction={"column"} columns={1} photos={images} onClick={openLightbox} margin={5} />
//        <ModalGateway>
//            {viewerIsOpen ? (
//                <Modal  onClose={closeLightbox}>
//                    <Carousel
//                        currentIndex={currentImage}
//                        views={images.map(x => ({
//                            ...x,
//                            srcset: x.srcSet,
//                            caption: x.title,
//                        }))}
//                    />
//                </Modal>
//            ) : null}
//        </ModalGateway>
//    </div>);}
//
//}

import React, { useState, useCallback } from "react";
import Gallery from "react-photo-gallery";
import Carousel, { Modal, ModalGateway } from "react-images";
import { imageList } from "../config/imageData";

const LAYOUT_ALL_IMAGES = imageList.filter(img =>
  img.path.includes("Background Layout") // 只取 Background Layout 下的图片
);
// 🌟 核心修改：把「全部」改成「All」，如需隐藏直接删除这一行即可
const CATEGORY_DATA = {
  "All":LAYOUT_ALL_IMAGES, // 替换「全部」为「All」
  "MoonGirl & Devil Dinosaur": imageList.filter(img =>
    img.path.includes("Moon Girl & Devil Dinosaur")
  ),
  "LEGO Monkie Kid": imageList.filter(img =>
    img.path.includes("LEGO Monkie Kid")
  ),
  "My Jumper It Roars": imageList.filter(img =>
    img.path.includes("My Jumper It Roars")
  )
};

// ❗ 如果你想完全隐藏「All」，直接用下面这个配置：
// const CATEGORY_DATA = {
//   "MoonGirl & Devil Dinosaur": imageList.filter(img =>
//     img.path.includes("Moon Girl & Devil Dinosaur")
//   ),
//   "LEGO Monkie Kid": imageList.filter(img =>
//     img.path.includes("LEGO Monkie Kid")
//   ),
//   "My Jumper It Roars": imageList.filter(img =>
//     img.path.includes("My Jumper It Roars")
//   )
// };

export default function BgLayoutImage() {
  // 状态默认选中 All（如果隐藏All则默认选中第一个分类）
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);
  const [activeCategory, setActiveCategory] = useState("All"); // 对应修改为All
  const [photos, setPhotos] = useState(CATEGORY_DATA["All"]); // 对应修改为All

  // 分类切换函数
  const changeCategory = (category) => {
    setActiveCategory(category);
    setPhotos(CATEGORY_DATA[category] || imageList);
  };

  // 图片预览
  const openLightbox = useCallback((event, { photo, index }) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  }, []);

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  // 样式（保持和你页面一致）
  const containerStyle = {
    width: "100%",
    padding: "0 20px",
    boxSizing: "border-box",
    marginTop: "20px"
  };

  const btnStyle = {
    padding: "8px 16px",
    margin: "0 8px 15px 0",
    border: "none",
    borderRadius: "4px",
    backgroundColor: "#f0f0f0",
    cursor: "pointer",
    fontSize: "14px",
    fontFamily: "华文细黑"
  };

  const activeBtnStyle = {
    ...btnStyle,
    backgroundColor: "#333",
    color: "white"
  };

  return (
    <div style={containerStyle}>
      {/* 分类按钮（显示All，样式不变） */}
      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        {Object.keys(CATEGORY_DATA).map((category) => (
          <button
            key={category}
            style={activeCategory === category ? activeBtnStyle : btnStyle}
            onClick={() => changeCategory(category)}
          >
            {category}
          </button>
        ))}
      </div>

      {/* 图片画廊 */}
      {photos.length > 0 ? (
        <Gallery
          photos={photos}
          onClick={openLightbox}
          columns={({ width }) => {
            if (width < 768) return 1;
            if (width < 1366) return 2;
            return 3;
          }}
          margin={10}
        />
      ) : (
        <div style={{ textAlign: "center", padding: "50px", fontFamily: "华文细黑" }}>
          No images in this category
        </div>
      )}

      {/* 预览弹窗 */}
      <ModalGateway>
        {viewerIsOpen ? (
          <Modal onClose={closeLightbox}>
            <Carousel
              currentIndex={currentImage}
              views={photos.map(x => ({
                src: x.src,
                width: x.width,
                height: x.height,
                caption: x.title
              }))}
            />
          </Modal>
        ) : null}
      </ModalGateway>
    </div>
  );
}